import request from '@/utils/request'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getGroups: async({ commit }, params) => {
        commit('SET_LOAD', true)

        await request({
            method: 'get',
            url: 'group/list',
            params
        }).then(res => {
            if (res.data && res.data.groups) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total,
                    limit: res.data.limit
                })

                commit('SET_GROUPS', res.data.groups.map(g => {
                    if (g.isDelivery && Number(g.clientsCount) === 0) {
                        g.deliveryAutomaticMode = true
                    }

                    if (g.isReachAmountBonus) {
                        g.bonusSystem = 'sum'
                    } else if (g.isTimeLimitedBonus) {
                        g.bonusSystem = 'count'
                    } else {
                        g.bonusSystem = 'cashbackPercent'
                    }

                    delete g.isReachAmountBonus
                    delete g.isTimeLimitedBonus

                    return g
                }))
                commit('SET_GROUP_STATISTIC', res.data.statistic)
            }
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },

    createOrEdit: async({ commit, dispatch }, data) => {
        const method = data.id ? 'put' : 'post'
        const url = data.id ? `/group/${data.id}` : '/group'

        return await request({
            method, url,
            data
        }).then(res => {
            if (res.data) {
                dispatch('addMessage', {
                    type: 'success',
                    message: 'success',
                    locale: true
                }, { root: true })

                if (data.id) {
                    commit('UPDATE_GROUP', res.data)
                }

                return true
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message,
                    locale: false
                }, { root: true })
            }
        })
    },

    createCustom: async({ dispatch }, data) => {
        return await request({
            method: 'post',
            url: '/group/custom',
            data
        }).then(res => {
            if (res.data) {
                dispatch('addMessage', {
                    type: 'success',
                    message: 'success',
                    locale: true
                }, { root: true })

                return res.data
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message,
                    locale: false
                }, { root: true })
            }
        })
    },

    check: async({ commit, dispatch }, data) => {
        return await request({
            method: 'post',
            url: '/group/check',
            data
        }).then(res => {
            if (res.data) {
                commit('SET_CLIENTS_COUNT', res.data.count)
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message,
                    locale: false
                }, { root: true })
            }
        })
    },

    removeGroup: async({ dispatch }, id) => {
        return await request({
            method: 'delete',
            url: `/group/${id}`,
            data: { id }
        }).then(res => {
            dispatch('addMessage', {
                type: 'success',
                message: 'success',
                locale: true
            }, { root: true })

            return res.status == 204
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message,
                    locale: false
                }, { root: true })
            }
        })
    },

    exportClientsToExcel: async({ dispatch }, groupId) => {
        await request({
            method: 'get',
            url: `/group/${groupId}/clients/excel`,
            responseType: 'blob'
        })
            .then(res => {
                if (res.data) {
                    downloadBlob(res.data, `Group-${groupId}-${uuid()}.xlsx`)

                    dispatch('addMessage', {
                        type: 'success',
                        message: 'success',
                        locale: true
                    }, { root: true })
                }
            }).catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        type: 'error',
                        message: error.response.data.message,
                        locale: false
                    }, { root: true })
                }
            })
    },

    statistic: async({ commit }, leaderId) => {
        await request({
            method: 'get',
            url: '/group/statistic',
            params: {
                leaderId
            }
        }).then(res => {
            const mutationType = leaderId ? 'SET_BUSINESS_GROUP_STATISTIC' : 'SET_GROUP_STATISTIC'

            commit(mutationType, res.data)
        })
    }
}
